module.exports = ".reauth-container{padding-top:20px;text-align:center}"